// Dynamic import failed: chunk removed by a newer deployment, or network dropped while loading it
const chunkLoadErrorMessages = [
  "Failed to fetch dynamically imported module", // Chromium
  "error loading dynamically imported module", // Firefox
  "Importing a module script failed" // Safari
];

export default function isChunkLoadError(err: unknown) {
  return err instanceof TypeError && chunkLoadErrorMessages.some((message) => err.message.includes(message));
}
